import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { ModuleColumn } from '../types';
import { brandColors } from '../theme/appTheme';

const statusStyle = (status: string) => {
  const s = status.toLowerCase();
  if (s === 'active') return { label: 'Active', bg: '#ecfdf5', color: '#047857', dot: '#10b981' };
  if (s === 'inactive') return { label: 'Inactive', bg: '#fef2f2', color: '#b91c1c', dot: '#ef4444' };
  return { label: status || '—', bg: '#f1f5f9', color: '#475569', dot: '#94a3b8' };
};

/** Clients list — clean, scannable columns */
export const clientTableColumns: ModuleColumn[] = [
  {
    field: 'clientName',
    header: 'Client',
    searchValue: (row) => String(row.clientName || ''),
    render: (row) => (
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: brandColors.textDark, lineHeight: 1.3 }}>
          {String(row.clientName || '—')}
        </Typography>
        {row.mobile ? (
          <Typography sx={{ fontSize: 11, color: brandColors.textMuted, mt: 0.25, lineHeight: 1.2 }}>
            {String(row.mobile)}
          </Typography>
        ) : null}
      </Box>
    ),
  },
  {
    field: 'companyFullName',
    header: 'Company',
    searchValue: (row) => String(row.companyFullName || ''),
    render: (row) => (
      <Typography sx={{ fontSize: 12.5, fontWeight: 500, color: brandColors.textDark }}>
        {String(row.companyFullName || '—')}
      </Typography>
    ),
  },
  {
    field: 'contactPerson',
    header: 'Contact',
    searchValue: (row) => String(row.contactPerson || ''),
    render: (row) => (
      <Typography sx={{ fontSize: 12.5, fontWeight: 500, color: brandColors.textDark }}>
        {String(row.contactPerson || '—')}
      </Typography>
    ),
  },
  {
    field: 'restHours',
    header: 'Rest Hrs',
    format: 'number',
    searchValue: (row) => String(row.restHours ?? ''),
  },
  {
    field: 'creditLimit',
    header: 'Credit Limit',
    format: 'currency',
    searchValue: (row) => String(row.creditLimit ?? ''),
  },
  {
    field: 'status',
    header: 'Status',
    searchValue: (row) => statusStyle(String(row.status || '')).label,
    exportValue: (row) => statusStyle(String(row.status || '')).label,
    render: (row) => {
      const style = statusStyle(String(row.status || ''));
      return (
        <Chip
          size="small"
          label={
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6 }}>
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: style.dot, flexShrink: 0 }} />
              {style.label}
            </Box>
          }
          sx={{
            bgcolor: style.bg,
            color: style.color,
            fontWeight: 600,
            fontSize: 11.5,
            height: 24,
            borderRadius: '999px',
            '& .MuiChip-label': { px: 1 },
          }}
        />
      );
    },
  },
];
